<template>
  <div class="layout-img">
    <slot name="title"></slot>
    <b-row>
      <template v-for="(item, index) in dataList">
        <b-col :key="index" :cols="cols" :md="md" class="block">
          <!-- item.type----判断是否为科学峰会 -->
          <router-link
            :to="(!item.type)?`/forum/project/list?type=${item.id}&index=${index}`:'/forum/project/citySummit'"
          >
            <div class="img-wrap img-hovor">
              <img width="100%" height="100%" :src="item.titleImg" />
            </div>
            <div>
              <p class="pItem">
                {{ item.title }}
              </p>
            </div>
          </router-link>
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: "activity",
    },
    md: Number,
    cols: Number,
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  watch: {
    dataList(val) {},
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.layout-img ::v-deep {
  .img-wrap {
    img:hover {
      transform: scale(1.05, 1.05);
      transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1),
        opacity 0.36s cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }

  a {
    text-decoration: none;
    cursor: pointer;
    color: #4a4a4a;
  }
}

@media (min-width: 992px) {
  .layout-img ::v-deep {
    .img-wrap {
      width: 98%;
      height: 16rem;
      margin: 1rem auto;

      img:hover {
        transform: scale(1.05, 1.05);
        transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1),
          opacity 0.36s cubic-bezier(0.215, 0.61, 0.355, 1);
      }
    }

    .row {
      margin: 0px !important;
    }

    .col-md-4,
    .col-7 {
      padding-right: 10px;
      padding-left: 10px;
    }

    .pItem {
      text-align: center;
      font-size: 15.9px;
      margin: 0;
      font-weight: 500;
      height: 47px;
    }
  }
}

@media (max-width: 768px) {
  .layout-img ::v-deep {
    .block {
      padding: 0.3rem;
      width: 10rem;
    }
    .block {
      margin-top:1.5rem  ;
      margin-bottom: 0.3rem  ;
      // margin: auto 0.3rem auto; 
    }
    .img-wrap {
      width: 87%;
      height: 73%;
      border-radius: 8px;
      margin: 0rem 1rem 0.8rem 1rem;
      display: flex;
      align-content: center;
    }

    .row {
      margin: 2rem 10px 0px 10px;
    }

    p {
      text-align: center;
      width: 14rem;
      margin-top: 0.5rem;
    }

    .pItem {
      width: 100%;
      text-align: center;
      font-size: 12.5px;
      margin: 0;
      font-weight: 500;
    }

    .col-md-4,
    .col-7 {
      padding-right: 0.1rem;
      padding-left: 0.1rem;
    }

    .row {
      flex-wrap: wrap;
    }
  }
}
</style>